import { useEffect, useState } from 'react';
import SkuSuppliersEditor from '../SkuSuppliersEditor';
import type { Sku, SkuSupplier } from '../../../types';

type EditableSupplier = Omit<SkuSupplier, 'id'> & { id?: string };

interface Props {
  sku: Sku;
  onSave: (suppliers: EditableSupplier[]) => void;
}

export function SkuSuppliersTab({ sku, onSave }: Props) {
  const [suppliers, setSuppliers] = useState<EditableSupplier[]>(sku.suppliers ?? []);

  useEffect(() => {
    setSuppliers(sku.suppliers ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sku.id]);

  return (
    <SkuSuppliersEditor
      suppliers={suppliers}
      onChange={(next) => {
        setSuppliers(next);
        onSave(next);
      }}
    />
  );
}
